import { render, staticRenderFns } from "./DateRangeField.vue?vue&type=template&id=05212552&lang=pug&"
import script from "./DateRangeField.vue?vue&type=script&lang=ts&"
export * from "./DateRangeField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports